function BaseFailoverConfigController($scope, ctrl){
    ctrl.originalConfig = null;

    ctrl.$onChanges = function (changes) {
     preInit();
     if(changes.defaults && changes.defaults.currentValue) {
       ctrl.updateDefaultsLabel();
     }
     if(changes.config && changes.config.currentValue) {
       ctrl.originalConfig = ctrl.config;
       ctrl.config = angular.copy(ctrl.config);
     }
     if(ctrl.doOnChanges && typeof ctrl.doOnChanges === "function"){
        ctrl.doOnChanges(changes);
     }
    }

    ctrl.defaultChanged = function (useDefault, fieldNames) {
     let fieldNamesArray = fieldNames.split(",").map(s => s.trim());
     for (let fieldName of fieldNamesArray) {
       if(useDefault) {
         delete ctrl.config[fieldName];
       } else {
           if(ctrl.originalConfig && ctrl.originalConfig[fieldName]) {
               ctrl.config[fieldName] = ctrl.originalConfig[fieldName];
           } else {
               ctrl.config[fieldName] = ctrl.defaults[fieldName];
           }
       }
     }
     ctrl.configChange();
    }

    ctrl.configChange = function () {
     if(ctrl.onConfigChanged) {
       if(!angular.equals(ctrl.config, ctrl.originalConfig)) {
         ctrl.onConfigChanged({current: ctrl.config, previous: ctrl.originalConfig, path: ctrl.path});
       }
     }
    }

    ctrl.isDefault = function(value) {
        return value == undefined || value == null;
    }

    function preInit() {
     if(!ctrl.config) {
         ctrl.config = {};
         ctrl.originalConfig = {};
     }
     if(!ctrl.defaults) {
         ctrl.defaults = {};
     }
    }

}